module.exports = __webpack_public_path__ + "img/sa.978acd9.svg";